import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, useNavigate, useRouteError, isRouteErrorResponse } from 'react-router-dom';
import { AlertOctagon, RotateCw, Home } from 'lucide-react';
import { Logo } from './Logo';
import { Card, CardDescription, CardTitle } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
/**
 * Écran d'erreur global utilisé par React Router (errorElement). Remplace
 * le fallback brut "Unexpected Application Error!" par quelque chose de
 * propre et actionnable. Affiche le message d'erreur en mode dev, le masque
 * en prod.
 */
export function ErrorScreen() {
    const error = useRouteError();
    const navigate = useNavigate();
    const isDev = import.meta.env.DEV;
    let title = 'Une erreur est survenue';
    let description = "Pas de panique. La plupart des erreurs se règlent en rafraîchissant la page.";
    let detail = null;
    if (isRouteErrorResponse(error)) {
        if (error.status === 404) {
            title = 'Page introuvable';
            description = "Le lien que tu as suivi n'existe pas (ou plus).";
        }
        else {
            title = `Erreur ${error.status}`;
            description = error.statusText;
        }
        detail = error.data ? String(error.data) : null;
    }
    else if (error instanceof Error) {
        detail = error.message;
    }
    return (_jsxs("div", { className: "min-h-dvh bg-ink-950", children: [_jsx("header", { className: "border-b border-ink-800/80 bg-ink-950/80 backdrop-blur-md", children: _jsx("div", { className: "mx-auto flex h-16 max-w-7xl items-center px-4 md:px-6", children: _jsx(Link, { to: "/", className: "flex items-center", "aria-label": "Retour \u00E0 l'accueil", children: _jsx(Logo, { size: "md" }) }) }) }), _jsx("main", { className: "mx-auto max-w-md px-4 py-12", children: _jsxs(Card, { variant: "elevated", padding: "lg", className: "text-center", children: [_jsx(AlertOctagon, { className: "mx-auto mb-3 h-12 w-12 text-flame-400 animate-bounce-soft" }), _jsx(CardTitle, { className: "text-2xl", children: title }), _jsx(CardDescription, { className: "mt-2", children: description }), isDev && detail && (_jsx("pre", { className: "mt-4 max-h-32 overflow-auto rounded-xl border border-ink-700 bg-ink-950 p-2 text-left text-2xs font-mono text-rose-300", children: detail })), _jsxs("div", { className: "mt-5 flex flex-wrap justify-center gap-2", children: [_jsx(Button, { variant: "secondary", leftIcon: _jsx(RotateCw, { className: "h-4 w-4" }), onClick: () => window.location.reload(), children: "Recharger" }), _jsx(Button, { variant: "primary", leftIcon: _jsx(Home, { className: "h-4 w-4" }), onClick: () => navigate('/'), children: "Accueil" })] })] }) })] }));
}
